import axios, { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { ArgumentosCodeudorDto, Codeudor } from "../models/codeudor";
import { ParticipanteRequest } from "../models/participantes";
import { SeguroCodeudorEdit } from "../models/seguroCodeudorEdit";
import { EliminarSeguro, SeguroCodeudor } from "../models/seguroCodeudor";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { selectorTransversal } from "../../../dtos/selector";

type MontoAseguradoResponse = {
  MontoAsegurado?: number;
  montoAsegurado?: number;
};

const getCodeudor = async (data: ParticipanteRequest) => {

  const axiosResponse: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-participantes/v1/participante-codeudor/obtener-codeudor`, {
    params: {
      rut: data.rut,
      mutuoId: data.mutuoId
    }
  });

  return axiosResponse;
}

const actualizarCodeudor = async (data: ArgumentosCodeudorDto) => {

  const axiosResponse: Promise<AxiosResponse> = axiosInstance.put(`siscred-api-participantes/v1/participante-codeudor/actualizar/codeudor/${data.mutuoId}`, data);

  return axiosResponse;
}

const guardarCodeudor = async (data: ArgumentosCodeudorDto) => {

  const axiosResponse: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-participantes/v1/participante-codeudor/guardar-codeudor`, data);

  return axiosResponse;
}

const deleteCodeudor = async (data: ParticipanteRequest) => {

  const axiosResponse: AxiosResponse = await axiosInstance.delete(`siscred-api-participantes/v1/participante-codeudor/eliminar/codeudor/${data.mutuoId}`, {
    params: {
      rut: data.rut,
      mutuoId: data.mutuoId
    }
  });

  return axiosResponse;
}

const getSegurosCodeudor = async (mutuoId: number, rutCodeudor: string | undefined) => {

  const axiosResponse: Promise<AxiosResponse<ListResponseDto<SeguroCodeudor>>> = axiosInstance.get(`siscred-api-participantes/v1/participante-codeudor/listar-seguros-codeudor`, {
    params: {
      mutuoId: mutuoId,
      rut: rutCodeudor
    }
  });

  return axiosResponse;
}

const getSeguroCodeudor = async (mutuoId: number, rut: string, tipoSeguro: string) => {

  const axiosResponse: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-participantes/v1/participante-codeudor/obtener-seguro-codeudor`, {
    params: {
      mutuoId: mutuoId,
      rutAsegurado: rut,
      tipoSeguro: tipoSeguro
    }
  });

  return axiosResponse;
}

const getCodigosPoliza = async (tipoSeguro: string) => {

  const axiosResponse: Promise<AxiosResponse<ListResponseDto<selectorTransversal>>> = axiosInstance.get(`siscred-api-participantes/v1/seguros-participantes-mutuo/obtener-codigo-poliza`, {
    params: {
      tipoSeguro: tipoSeguro,
    }
  });

  return axiosResponse;
}

const getCodPolizasInternas = async (codigo: string, tipoSeguro: string) => {

  const axiosResponse: Promise<AxiosResponse<ListResponseDto<selectorTransversal>>> = axiosInstance.get(`siscred-api-participantes/v1/seguros-participantes-mutuo/obtener-poliza-hijo`, {
    params: {
      codigo: codigo,
      tipoSeguro: tipoSeguro
    }
  });

  return axiosResponse;
}

const updateSeguroCodeudor = async (data: SeguroCodeudorEdit) => {

  const axiosResponse = axiosInstance.put(`siscred-api-participantes/v1/participante-codeudor/actualizar/seguro/${data.mutuoId}`, data);

  return axiosResponse;
}

const createSeguroCodeudor = async (data: SeguroCodeudorEdit) => {

  const axiosResponse = axiosInstance.post(`siscred-api-participantes/v1/participante-codeudor/nuevo-seguro`, data);

  return axiosResponse;
}

const getMontoAsegurado = async (mutuoId: number, tipoSeguro: string) => {

  const axiosResponse = await axiosInstance.get<MontoAseguradoResponse>(`siscred-api-participantes/v1/participante-codeudor/obtener-monto-asegurado`, {
    params: {
      mutuoId: mutuoId,
      tipoSeguro: tipoSeguro
    }
  });

  return axiosResponse.data?.MontoAsegurado ?? axiosResponse.data?.montoAsegurado ?? 0;
}

const deleteSeguroCodeudor = async (data: EliminarSeguro) => {

  const axiosResponse: Promise<AxiosResponse> = axiosInstance.delete(`siscred-api-participantes/v1/participante-codeudor/eliminar-seguro/codeudor/${data.mutuoId}`, {
    params: {
      mutuoId: data.mutuoId,
      rut: data.rut,
      tipoSeguro: data.tipoSeguro
    }
  });

  return axiosResponse;
}


export {
  getCodeudor,
  actualizarCodeudor,
  guardarCodeudor,
  getSegurosCodeudor,
  getSeguroCodeudor,
  getCodigosPoliza,
  getCodPolizasInternas,
  updateSeguroCodeudor,
  createSeguroCodeudor,
  getMontoAsegurado,
  deleteCodeudor,
  deleteSeguroCodeudor
}